import React from 'react';
export function SchemaMarkup() {
  const faqEntries = [{
    question: 'What ages do you care for at Funtastic Kidz?',
    answer: 'We care for children from 6 weeks to 5 years old. Our programs are divided into Nursery (6 weeks to 2 years), Toddlers (2-3 years), and Pre-Kinder & Kindergarten (3-5 years), each designed for specific developmental stages.'
  }, {
    question: 'Are you CCS approved?',
    answer: 'Yes, Funtastic Kidz is a fully approved Child Care Subsidy (CCS) provider. Eligible families can claim the subsidy to reduce their daily out-of-pocket costs. We can help you understand how to apply through Services Australia.'
  }, {
    question: 'What is the 3 Day Guarantee and do I qualify?',
    answer: 'From 5 January 2026, the 3 Day Guarantee automatically provides 72 subsidised hours per fortnight (3 days a week) to every CCS-eligible family with a household income under $530,000, regardless of activity test results.'
  }, {
    question: 'What are your daily fees?',
    answer: 'Our daily fee is $118. This is significantly lower than the Wyndham Vale suburb average of $144. With the Child Care Subsidy applied, many families pay from around $24 to $35 per day out-of-pocket.'
  }, {
    question: 'What are your opening hours?',
    answer: 'We are open Monday to Friday from 6:30am to 6:30pm. We are closed on weekends and Victorian public holidays.'
  }, {
    question: 'What meals do you provide?',
    answer: 'We provide five fresh, nutritious meals daily prepared on-site: breakfast, morning tea, lunch, afternoon tea, and an evening snack. We cater to dietary, cultural, and religious requirements.'
  }, {
    question: 'What does my child need to bring?',
    answer: 'Please bring formula if required, a labelled water bottle, a labelled sunhat, a change of clothes, and a dummy or comforter if your child uses one. We provide nappies, blankets for rest, and all meals.'
  }, {
    question: 'Can I visit my child during the day?',
    answer: 'Yes, parents are always welcome to visit their child throughout the day. We have an open-door policy for enrolled families.'
  }, {
    question: 'What if my child is unwell?',
    answer: 'If your child becomes unwell during the day, we will contact you immediately to collect them. Our illness policy aligns with the Victorian Department of Health guidelines to protect all children and staff.'
  }, {
    question: 'Do children need to be immunised?',
    answer: "Yes, under the 'No Jab, No Play' legislation, children must have an up-to-date immunisation certificate or valid medical exemption documentation to enrol and attend."
  }, {
    question: 'How do I book a tour?',
    answer: 'You can book a tour directly through our website using the booking form, or by calling us on 03 8714 3350. We offer tours on Tuesdays, Wednesdays, and Thursdays.'
  }, {
    question: 'How do I enrol?',
    answer: "After your tour, if you decide to proceed, we will provide you with an enrolment pack. You'll need to complete the forms, provide your child's birth certificate, immunisation history, and your CRN details for CCS."
  }, {
    question: "What's your NQS rating?",
    answer: "Funtastic Kidz is rated as 'Meeting National Quality Standard' (NQS) by ACECQA. Our last regulatory assessment was in September 2025."
  }, {
    question: 'How is Funtastic Kidz different from Goodstart or Busy Bees?',
    answer: 'Funtastic Kidz is a family-run, owner-operated centre, not a national chain. This means lower overheads, allowing us to charge $118/day compared to chain rates of $158-$176/day, while maintaining high-quality care and personal relationships.'
  }, {
    question: 'Where is Funtastic Kidz exactly?',
    answer: 'We are located at 4 Brightfield Street, Wyndham Vale VIC 3024. We are conveniently situated for families in Wyndham Vale, Manor Lakes, and surrounding suburbs.'
  }];
  const schema = {
    '@context': 'https://schema.org',
    '@graph': [{
      '@type': ['LocalBusiness', 'EducationalOrganization', 'ChildCare', 'Organization'],
      '@id': 'https://www.funtastickidz.vic.edu.au/#organization',
      name: 'Funtastic Kidz Early Learning Centre',
      url: 'https://www.funtastickidz.vic.edu.au/',
      logo: 'https://cdn.magicpatterns.com/uploads/2zHGBywaBCAxo8bMoxkHDW/Funtastic-kidz-logo.svg',
      image: 'https://cdn.magicpatterns.com/uploads/2zHGBywaBCAxo8bMoxkHDW/Funtastic-kidz-logo.svg',
      description: 'Family-run early learning centre in Wyndham Vale offering childcare from 6 weeks to kindergarten. $118/day. CCS approved.',
      telephone: '0387143350',
      email: 'wyndham@funtastickidz.vic.edu.au',
      address: {
        '@type': 'PostalAddress',
        streetAddress: '4 Brightfield Street',
        addressLocality: 'Wyndham Vale',
        addressRegion: 'VIC',
        postalCode: '3024',
        addressCountry: 'AU'
      },
      geo: {
        '@type': 'GeoCoordinates',
        latitude: '-37.8995',
        longitude: '144.6035'
      },
      openingHoursSpecification: {
        '@type': 'OpeningHoursSpecification',
        dayOfWeek: ['Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday'],
        opens: '06:30',
        closes: '18:30'
      },
      priceRange: '$118/day',
      founder: {
        '@type': 'Person',
        name: 'Sanjay Sharma',
        jobTitle: 'Director'
      },
      aggregateRating: {
        '@type': 'AggregateRating',
        ratingValue: '4.0',
        reviewCount: '106',
        bestRating: '5'
      },
      contactPoint: {
        '@type': 'ContactPoint',
        telephone: '+61-3-8714-3350',
        contactType: 'customer service',
        email: 'wyndham@funtastickidz.vic.edu.au',
        availableLanguage: 'English',
        hoursAvailable: {
          '@type': 'OpeningHoursSpecification',
          dayOfWeek: ['Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday'],
          opens: '06:30',
          closes: '18:30'
        }
      }
    }, {
      '@type': 'FAQPage',
      '@id': 'https://www.funtastickidz.vic.edu.au/#faq',
      mainEntity: faqEntries.map(faq => ({
        '@type': 'Question',
        name: faq.question,
        acceptedAnswer: {
          '@type': 'Answer',
          text: faq.answer
        }
      }))
    }, {
      '@type': 'BreadcrumbList',
      itemListElement: [{
        '@type': 'ListItem',
        position: 1,
        name: 'Home',
        item: 'https://www.funtastickidz.vic.edu.au/'
      }]
    }, {
      '@type': 'WebSite',
      '@id': 'https://www.funtastickidz.vic.edu.au/#website',
      url: 'https://www.funtastickidz.vic.edu.au/',
      name: 'Funtastic Kidz Early Learning Centre',
      potentialAction: {
        '@type': 'SearchAction',
        target: 'https://www.funtastickidz.vic.edu.au/?s={search_term_string}',
        'query-input': 'required name=search_term_string'
      }
    }]
  };
  return <script type="application/ld+json" dangerouslySetInnerHTML={{
    __html: JSON.stringify(schema)
  }} data-id="element-382" />;
}